import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import React, { useState, useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import { CheckboxSlider } from 'ui-components/components/checkbox-slider';
import { Text, TextType } from 'ui-components/components/text';

import style from './style.module.less';
import { ShippingStrategyDefaultTag } from '../../../../../components/shipping-strategy-default-tag';
import { useRateShopperContext } from '../../context/rate-shopper-context';
import { SettingsPageEvents, useTrackRateShopperEvent } from '../../hooks/use-track-rate-shopper-analytic-events';
import messages from '../rate-shopper-page/messages';
import { ShopperDetail } from '../shopper-detail';
// TODO: come back to this and rename in the whole app (maybe part of grid effort)
// @ts-expect-error less import

/**
 * @typedef {import('../../../../../prop-types/rate-shopper').RateShopper} RateShopper
 */

/**
 * @param {object} props
 * @param {RateShopper} props.shopper
 * @returns {JSX.Element}
 */
export const Shopper = ({ shopper }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const expandIcon = isExpanded ? faChevronUp : faChevronDown;
  const { isTemplate } = shopper;
  const [isRateShopperActive, setIsRateShopperActive] = useState(shopper.isActive);
  const { toggleActiveRateShopper } = useRateShopperContext();

  const trackToggleActivate = useTrackRateShopperEvent(SettingsPageEvents.RATE_SHOPPER_TOGGLE_ACTIVATE, { shopperName: shopper.name });

  const trackToggleDeactivate = useTrackRateShopperEvent(SettingsPageEvents.RATE_SHOPPER_TOGGLE_DEACTIVATE, { shopperName: shopper.name });

  const trackToggle = useCallback(() => {
    if (isRateShopperActive) {
      trackToggleDeactivate();
    } else {
      trackToggleActivate();
    }
  }, [isRateShopperActive, trackToggleActivate, trackToggleDeactivate]);

  const toggleRateShopper = useCallback(async () => {
    trackToggle();

    const newStatus = !isRateShopperActive;
    setIsRateShopperActive(newStatus);
    const result = await toggleActiveRateShopper(shopper.serviceCollectionGuid, newStatus);
    if (!result) {
      setIsRateShopperActive(isRateShopperActive);
    }
  }, [isRateShopperActive, shopper.serviceCollectionGuid, toggleActiveRateShopper, trackToggle]);

  const trackExpandEvent = useTrackRateShopperEvent(SettingsPageEvents.RATE_SHOPPER_EXPAND, { shopperName: shopper.name });

  const onSetExpandedChange = useCallback(() => {
    if (!isExpanded) {
      trackExpandEvent();
    }
    setIsExpanded(!isExpanded);
  }, [isExpanded, trackExpandEvent]);

  return (
    <div className={style.shopper}>
      <div className={style['shopper-head']} onClick={onSetExpandedChange}>
        <div className={style['shopper-details']}>
          <Text textType={TextType.H3} value={shopper.name} />
          {isTemplate ? <ShippingStrategyDefaultTag /> : null}
        </div>
        <div className={style['shopper-controls']}>
          <Text className={style.available} textType={TextType.Paragraph} value={messages.available} />
          <CheckboxSlider
            checkboxId={shopper.serviceCollectionGuid}
            checked={isRateShopperActive}
            onChange={toggleRateShopper}
            shouldStopEventPropagation
          />
          <Button theme='unstyled'>
            <FontAwesomeIcon className={style['expand-icon']} icon={expandIcon} />
          </Button>
        </div>
      </div>
      {isExpanded ? <ShopperDetail shopper={shopper} /> : null}
    </div>
  );
};
